import { formatDate } from "./localizations";

export default function fileNameWithDate(fileName: string, fileExtension: string, date: Date) {
  const dateString = formatDate(date);
  return `${fileName}-${dateString}.${fileExtension}`.replace(/\s+/g, "");
}
